import { useAuth } from '../lib/auth';
import { GoogleMark, Icon } from '../components/Icons';

export default function SignIn({ pendingInvite }: { pendingInvite: string | null }) {
  const { signIn, error } = useAuth();

  const points = [
    ['households', 'Couples and families settle as one. Nobody ends up owing their own spouse.'],
    ['trips', 'Kids count as a full share, half a share, or nothing — your call, per trip.'],
    ['settle', 'Everyone clears in the fewest payments possible, not everyone paying everyone.']
  ];

  return (
    <div className="signin">
      <div className="mark">evenhouse<em>.</em></div>
      <p className="tag">
        Shared expenses for trips where whole families travel together.
      </p>

      <div className="pts">
        {points.map(([icon, text]) => (
          <div className="pt" key={text}>
            <Icon name={icon} />
            <span>{text}</span>
          </div>
        ))}
      </div>

      {pendingInvite && (
        <div className="banner" style={{ marginBottom: 14 }}>
          <Icon name="link" />
          <div>You've been invited to a trip. <b>Sign in to join it.</b></div>
        </div>
      )}

      {error && (
        <div className="note" style={{ marginBottom: 14, background: 'var(--clay-soft)' }}>
          <Icon name="info" />
          <div>{error}</div>
        </div>
      )}

      <button className="gbtn" onClick={() => void signIn()}>
        <GoogleMark />
        <span>Continue with Google</span>
      </button>

      <p className="muted" style={{ fontSize: 12, lineHeight: 1.55, marginTop: 14, textAlign: 'center' }}>
        Evenhouse records who owes whom. It never moves money.
      </p>
    </div>
  );
}
